// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-container {
    position: absolute;
    top: -75px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 6px;
    gap: 8px;
    padding: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    min-height: 40px;
  }
  
  .bold-icon {
    cursor: pointer;
    transition: color 0.2s ease-in-out;
  }
  
  .bold-icon:hover {
    /* color: #444; */
    background-color: #b8ddf8;
    border-radius: 6px;
  }
  

  .color-picker-container {
    position: relative;
    display: flex;
    align-items: center;
  }
  
  .color-picker-icon {
    cursor: pointer;
    border-radius: 6px;
  }
  
  .color-picker-icon:hover {
    /* color: #444; */
    background-color: #b8ddf8 !important;
  }

  .color-picker-input {
    position: absolute;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  .toolbar-icon {
    cursor: pointer;
    font-size: 30px;
    padding: 4px;
    margin-right: -4px;
  }

  .toolbar-icon:hover {
    /* color: #444; */
    background-color: #b8ddf8;
    border-radius: 6px;
  }

  .trash-icon {
    cursor: pointer;
    color: #ff4d4d;
    font-size: 30px !important;
    padding: 4px;
    margin-right: 0px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/birthday/Toolbar.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;EACpB;;;EAGA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;EACnB","sourcesContent":[".toolbar-container {\r\n    position: absolute;\r\n    top: -75px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    display: flex;\r\n    align-items: center;\r\n    background: #fff;\r\n    border: 1px solid #ccc;\r\n    border-radius: 6px;\r\n    gap: 8px;\r\n    padding: 8px;\r\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\r\n    min-height: 40px;\r\n  }\r\n  \r\n  .bold-icon {\r\n    cursor: pointer;\r\n    transition: color 0.2s ease-in-out;\r\n  }\r\n  \r\n  .bold-icon:hover {\r\n    /* color: #444; */\r\n    background-color: #b8ddf8;\r\n    border-radius: 6px;\r\n  }\r\n  \r\n\r\n  .color-picker-container {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .color-picker-icon {\r\n    cursor: pointer;\r\n    border-radius: 6px;\r\n  }\r\n  \r\n  .color-picker-icon:hover {\r\n    /* color: #444; */\r\n    background-color: #b8ddf8 !important;\r\n  }\r\n\r\n  .color-picker-input {\r\n    position: absolute;\r\n    left: 0;\r\n    opacity: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .toolbar-icon {\r\n    cursor: pointer;\r\n    font-size: 30px;\r\n    padding: 4px;\r\n    margin-right: -4px;\r\n  }\r\n\r\n  .toolbar-icon:hover {\r\n    /* color: #444; */\r\n    background-color: #b8ddf8;\r\n    border-radius: 6px;\r\n  }\r\n\r\n  .trash-icon {\r\n    cursor: pointer;\r\n    color: #ff4d4d;\r\n    font-size: 30px !important;\r\n    padding: 4px;\r\n    margin-right: 0px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
